import { Controller } from '@hotwired/stimulus'
import Logger from '../lib/logger'

export default class extends Controller {
  static targets = ['button', 'loading']

  connect() {
    Logger.debug('Controller connected', { controller: this.constructor.name })
  }

  disconnect() {
    Logger.debug('Controller disconnected', { controller: this.constructor.name })
  }

  showLoading() {
    if (this.hasButtonTarget) {
      this.buttonTarget.style.display = 'none'
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = 'inline-block'
    }
  }

  reset() {
    if (this.hasButtonTarget) {
      this.buttonTarget.style.display = 'inline-block'
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = 'none'
    }
  }
}
